// access:change event bus. The SDK emits access:change when the visitor's access
// may have changed (auth refresh, checkout completion, logout); publishers
// subscribe with ezsubscriptions.on to re-render gated content. A single bus per
// page instance is sufficient since the SDK is a singleton.

import type { AccessChangeHandler, Unsubscribe } from '@/types';
import { logError } from '@/sdkConsole';

const handlers = new Set<AccessChangeHandler>();

// on subscribes a handler and returns a function that removes it, so callers can
// unsubscribe without retaining the original reference for off.
export function on(handler: AccessChangeHandler): Unsubscribe {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

export function off(handler: AccessChangeHandler): void {
  handlers.delete(handler);
}

// emit runs every subscribed handler. A throwing handler is logged and never
// allowed to block the others.
export function emit(): void {
  for (const handler of handlers) {
    try {
      handler();
    } catch (err) {
      logError('access:change handler failed', err);
    }
  }
}
